
export default {
  name: 'CartPanel',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    success: {
      type: Boolean,
      default: false,
    },
    inlineAction: {
      type: Boolean,
      default: false,
    },
  },
}
